module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1@3x.fa508bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1@3x.png
// module id = Nz+P
// module chunks = 18